import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface NewProductFormState {
  name: string;
  sku: string;
  description: string;
  badge: string;
  price: string;
  categoryId: string;
  gender: 'hombre' | 'mujer' | 'unisex';
  brand: string;
  material: string;
  color: string;
  isFeatured: boolean;
  isActive: boolean;
  sizes: string[];
  promoType: string;
  promoName: string;
  promoBuyQty: string;
  promoPayQty: string;
  promoDiscountValue: string;
  promoLabel: string;
  promoDescription: string;
  promoStartsAt: string;
  promoEndsAt: string;
}

export const newProductInitial: NewProductFormState = {
  name: '',
  sku: '',
  description: '',
  badge: '',
  price: '',
  categoryId: '',
  gender: 'unisex',
  brand: '',
  material: '',
  color: '',
  isFeatured: false,
  isActive: true,
  sizes: [],
  promoType: 'none',
  promoName: '',
  promoBuyQty: '',
  promoPayQty: '',
  promoDiscountValue: '',
  promoLabel: '',
  promoDescription: '',
  promoStartsAt: '',
  promoEndsAt: '',
};

const newProductSlice = createSlice({
  name: 'newProduct',
  initialState: newProductInitial,
  reducers: {
    patch(state, { payload }: PayloadAction<Partial<NewProductFormState>>) {
      return { ...state, ...payload };
    },
    reset() {
      return newProductInitial;
    },
    toggleSize(state, { payload }: PayloadAction<string>) {
      const idx = state.sizes.indexOf(payload);
      if (idx >= 0) {
        state.sizes.splice(idx, 1);
      } else {
        state.sizes.push(payload);
      }
    },
  },
});

export const {
  patch: patchNewProduct,
  reset: resetNewProduct,
  toggleSize: toggleNewProductSize,
} = newProductSlice.actions;

export default newProductSlice.reducer;
